import React from 'react';

const BusinessLogoSmall = ({ business, className }) => {
    return (
        <span
            className={`w-6 h-6 rounded bg-primary-700 text-xs text-white p-2 flex items-center justify-center ${className}`}
        >
            {business?.name?.substring(0, 1)}
        </span>
    );
};

export default BusinessLogoSmall;
